import React from 'react'
import { View, Text, StyleSheet, Image, ScrollView } from 'react-native'
import { useLocalSearchParams } from 'expo-router'
import { posts } from '@/content/blog/posts'
import BlogCTA from '@/components/BlogCTA'
import { useTheme } from '@/contexts/ThemeContext'

export default function BlogPostFallback() {
  const { slug } = useLocalSearchParams<{ slug: string }>()
  const post = posts.find((p) => p.slug === slug)
  const { colors } = useTheme()

  const styles = StyleSheet.create({
    container: {
      flex: 1,
      backgroundColor: colors.background,
    },
    header: {
      paddingHorizontal: 24,
      paddingVertical: 24,
      gap: 8,
    },
    title: {
      fontSize: 26,
      fontFamily: 'Inter-Bold',
      color: colors.text,
    },
    meta: {
      fontSize: 12,
      fontFamily: 'Inter-Regular',
      color: colors.textSecondary,
    },
    cover: {
      width: '100%',
      height: 260,
      marginTop: 12,
      borderRadius: 12,
    },
    content: {
      paddingHorizontal: 24,
      paddingBottom: 40,
      gap: 16,
    },
    paragraph: {
      color: colors.text,
      fontFamily: 'Inter-Regular',
      lineHeight: 24,
      fontSize: 16,
    },
    note: {
      color: colors.textSecondary,
      fontFamily: 'Inter-Regular',
      fontSize: 12,
    },
  })

  if (!post) {
    return (
      <ScrollView style={styles.container}>
        <View style={styles.header}>
          <Text style={styles.title}>Artigo não encontrado</Text>
          <Text style={styles.meta}>Verifique o link e tente novamente.</Text>
        </View>
      </ScrollView>
    )
  }

  return (
    <ScrollView style={styles.container} contentContainerStyle={{ paddingBottom: 40 }}>
      <View style={styles.header}>
        <Text style={styles.title}>{post.title}</Text>
        <Text style={styles.meta}>{new Date(post.date).toLocaleDateString('pt-BR')}</Text>
        {post.imageUrl ? (
          <Image source={{ uri: post.imageUrl }} style={styles.cover} resizeMode="cover" />
        ) : null}
      </View>

      <View style={styles.content}>
        {post.excerpt ? <Text style={styles.paragraph}>{post.excerpt}</Text> : null}
        <Text style={styles.paragraph}>{post.content}</Text>
        <Text style={styles.note}>Renderização simplificada no app; formatação completa disponível na web.</Text>
        <BlogCTA />
      </View>
    </ScrollView>
  )
}
